export enum AssignmentPriorityOptions {
  URGENT = 'ec42aafb-8776-4c45-a39d-57a932a9fe3d',
  HIGH = '2ead410f-e0b3-46a7-b09d-87eeccda686e',
  MEDIUM = 'd092cf54-cb3f-4cab-b30c-4dd2df0812c0',
  LOW = 'cf715363-f75f-470d-9327-88a0b2452095'
}
